import { useTheme } from "@mui/material";
import { useMemo } from "react";

// Series colors that hold up on both the dark and the light surface.
export const CHART_SERIES_COLORS = [
  "#6aa9ff",
  "#34c77b",
  "#f5a524",
  "#f0508c",
  "#a78bfa",
  "#22c3d6",
  "#f0554a",
  "#9ccc65",
  "#7986cb",
  "#ffd54f",
];

// Shared recharts styling so every chart reads the same:
//   <CartesianGrid {...chart.grid} />
//   <XAxis dataKey="x" {...chart.axis} />
//   <Tooltip {...chart.tooltip} />
//   <Legend {...chart.legend} />
export function useChartTheme() {
  const theme = useTheme();

  return useMemo(
    () => ({
      colors: CHART_SERIES_COLORS,
      // Color for comparison / previous period series
      mutedSeries: theme.mutedTextColor,
      grid: {
        strokeDasharray: "3 3",
        stroke: theme.border,
        vertical: false,
      },
      axis: {
        stroke: theme.mutedTextColor,
        fontSize: 12,
        tickLine: false,
        axisLine: { stroke: theme.border },
      },
      tooltip: {
        contentStyle: {
          backgroundColor: theme.surfaceRaised,
          border: `1px solid ${theme.border}`,
          borderRadius: 8,
          boxShadow: theme.shadow.md,
          color: theme.textColor,
          fontSize: 12.5,
          padding: "8px 10px",
        },
        labelStyle: {
          color: theme.secondaryTextColor,
          fontWeight: 600,
          marginBottom: 4,
        },
        itemStyle: { padding: "1px 0" },
        cursor: { stroke: theme.borderStrong, fill: theme.surfaceHover },
      },
      legend: {
        iconType: "circle" as const,
        iconSize: 8,
        wrapperStyle: {
          fontSize: 12.5,
          color: theme.secondaryTextColor,
          paddingTop: 8,
        },
      },
    }),
    [theme],
  );
}
